<template>
  <div>
    <div>近七日抓取量</div>
    <div id="main"></div>
  </div>
</template>

<script>
import { statistics } from '@/api/data'
import * as echarts from 'echarts'
export default {
  data() {
    return {

    }
  },
  mounted() {
    this.reqStatistics()
  },
  methods: {
    reqStatistics() {
      statistics().then(res => {
        const xData = (res.data || []).map(v => v.taskCreateDate)
        const yData1 = (res.data || []).map(v => v.totalActiveUsers)
        const yData2 = (res.data || []).map(v => v.totalUsers)
        this.getInit(xData, yData1, yData2)
      })
    },
    getInit(xData, yData1, yData2) {
      // 基于准备好的dom，初始化echarts实例
      const eChart = document.getElementById('main')
      if (!eChart) return
      const chart = echarts.init(eChart)
      // 指定图表的配置项和数据
      var option = {
        tooltip: {
          trigger: 'axis',
          extraCssText: 'z-index:1001; box-shadow : 0 0 5px #ccc',
          axisPointer: {
            lineStyle: {
              type: 'solid',
              color: '#BFBFBF'
            }
          }
        },
        legend: {
          left: 'center',
          bottom: 0,
          orient: 'horizontal',
          icon: 'circle',
          itemWidth: 10
          // textStyle: {
          //   height: 9,
          //   rich: {
          //     a: {
          //       verticalAlign: 'middle'
          //     }
          //   }
          // }
        },
        xAxis: {
          type: 'category',
          data: xData
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            name: '有效WA量',
            data: yData1,
            type: 'line'
          },
          {
            name: '抓取总量',
            data: yData2,
            type: 'line'
          }
        ]
      }
      // 使用刚指定的配置项和数据显示图表。
      chart.setOption(option)
    }
  }
}
</script>

<style lang="scss" scoped>
#main {
  width: 100%;
  height: calc(100vh - 200px);
}
/deep/ .el-tabs {
  width: 100%;
}
</style>
